export const ROLES = {
    ADMIN: 'admin',
    USER: 'user'
}

export const AUTHENTICATION_ENDPOINT = 'https://asia-east2-pannana-ml.cloudfunctions.net/authenticate'